<template>
  <div>
    <div class="picsArea">
      <!--
      <carousel-3d>
        <slide v-for="(item, i) in serverItems" :index="i" :key="i">
          <template slot-scope="{ index, isCurrent, leftIndex, rightIndex }">
            <v-img
              :data-index="index"
              :class="{
                current: isCurrent,
                onLeft: leftIndex >= 0,
                onRight: rightIndex >= 0,
              }"
              contain
              :src="item.filepng"
              :alt="item.filename"
              style="height: 80%"
            ></v-img>
          </template>
        </slide>
      </carousel-3d>
      -->

      <v-carousel
        :continuous="false"
        :cycle="cycle"
        :show-arrows="arrow"
        hide-delimiter-background
        delimiter-icon="mdi-minus"
        height="100%"
      >
        <v-row
          class="mx-auto pt-2 ml-10 mr-10"
          width="200px"
          justify="center"
          align="center"
        >
          <v-autocomplete
            v-model="select"
            :loading="loading"
            color="#d3d3d3"
            item-color="#d3d3d3"
            :items="items"
            :search-input.sync="search"
            prepend-icon="mdi-magnify"
            dense
            cache-items
            hide-no-data
            hide-details
            label="Which file you are looking for?"
          ></v-autocomplete>
        </v-row>

        <v-carousel-item v-for="item in serverItems" :key="item.filepng">
          <v-row class="fill-height mt-n10" justify="center" align="center">
            <v-img
              @click="funcc(item.fileglb, item.id)"
              contain
              :src="item.filepng"
              :alt="item.filepng"
              style="height: 80%"
            ></v-img>
          </v-row>
        </v-carousel-item>
      </v-carousel>
    </div>
    <div class="foldersArea">
      <v-card class="mx-auto">
        <v-list>
          <v-list-item
            v-for="item in serverItems"
            :key="item.id"
            @click="delete1"
          >
            <v-list-item-avatar>
              <v-avatar>
                <img :src="item.filepng" alt="Loading..." />
              </v-avatar>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title v-text="item.filename"></v-list-item-title>
              <v-list-item-subtitle
                v-text="item.subtitle"
              ></v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-btn icon>
                <v-icon color="grey lighten-1" @click="printEd(item.id)"
                  >mdi-magnify</v-icon
                >
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn icon>
                <v-icon color="grey lighten-1" @click="printDe(item.id)"
                  >mdi-delete</v-icon
                >
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>

      <!--
      <v-container class="ma-0 pa-0" fill-height fluid>
        
        <v-row justify="center" align="center">
          <v-col justify="center" align="center">
            
            
            <v-btn  icon>
              <v-icon>mdi-folder-outline</v-icon>
            </v-btn>

            <v-btn  icon>
              <v-icon>mdi-folder-outline</v-icon>
            </v-btn>
            <v-btn  icon>
              <v-icon>mdi-folder-outline</v-icon>
            </v-btn>
            <v-btn icon>
              <v-icon>mdi-folder-outline</v-icon>
            </v-btn>
            <br />
            <v-btn icon>
              <v-icon>mdi-folder-outline</v-icon>
            </v-btn>

            <v-btn icon>
              <v-icon>mdi-folder-outline</v-icon>
            </v-btn>
            <v-btn icon>
              <v-icon>mdi-folder-outline</v-icon>
            </v-btn>
            <v-btn icon>
              <v-icon>mdi-folder-outline</v-icon>
            </v-btn>
            
          </v-col>
        </v-row>
        
      </v-container>
      -->
    </div>
  </div>
</template>

<script>
import axios from "axios";

axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";

import store from "../store";

//import { Carousel3d, Slide } from "vue-carousel-3d";

export default {
  name: "CMS",
  components: {
    //Carousel3d,
    //Slide,
  },
  data: function () {
    return {
      colors: [
        "green",
        "secondary",
        "yellow darken-4",
        "red lighten-2",
        "orange darken-1",
      ],
      cycle: true,
      arrow: true,
      slides: ["First", "Second", "Third", "Fourth", "Fifth"],
      items: [
        "static/assets/images/screenshot.png",
        "static/assets/images/screenshot(1).png",
        "static/assets/images/screenshot(2).png",
        "static/assets/images/screenshot(3).png",
        "static/assets/images/screenshot.png",
        "static/assets/images/screenshot(1).png",
        "static/assets/images/screenshot(2).png",
        "static/assets/images/screenshot(3).png",
      ],

      loading: true,
      serverItems: [],

      items1: [
        {
          icon: "folder",
          iconClass: "grey lighten-1 white--text",
          title: "Photos",
          subtitle: "Jan 9, 2014",
        },
        {
          icon: "folder",
          iconClass: "grey lighten-1 white--text",
          title: "Recipes",
          subtitle: "Jan 17, 2014",
        },
        {
          icon: "folder",
          iconClass: "grey lighten-1 white--text",
          title: "Work",
          subtitle: "Jan 28, 2014",
        },
      ],
      items2: [
        {
          icon: "mdi-file",
          title: "Vacation itinerary",
          subtitle: "Jan 20, 2014",
        },
        {
          icon: "mdi-file",
          title: "Kitchen remodel",
          subtitle: "Jan 10, 2014",
        },
      ],
    };
  },
  mounted() {
    axios
      .get(this.$abServerPath + "/api/glbfiles/glbgetallfile/") //for local "/api/glb/glbgetallfile/"
      .then((response) => {
        var i;
        var len;

        //console.log(response.data.length);
        this.serverItems = response.data;
        //console.log(this.serverItems);
        //console.log(this.serverItems[0]);
        //console.log(this.items);
        //console.log(response.data[2].filepng);

        for (i = 0, len = response.data.length; i < len; i++) {
          console.log(response.data[i]);
          this.serverItems[i].filepng =
            this.$abServerPath + response.data[i].filepng; //for local " "" + response.data[i].filepng "
          this.serverItems[i].filename = response.data[i].filename;
          this.serverItems[i].filetype = response.data[i].filetype;
          this.serverItems[i].fileglb =
            this.$abServerPath + response.data[i].fileglb;
          this.serverItems[i].fileusdz =
            this.$abServerPath + response.data[i].fileusdz;
          console.log(this.serverItems[i].fileglb);
          this.serverItems[i].filedescription = response.data[i].description;
          this.serverItems[i].filetag = response.data[i].tags;
          this.serverItems[i].filestate = response.data[i].state;
          this.serverItems[i].filecreated = response.data[i].created_at;
          this.serverItems[i].fileupdated = response.data[i].updated_at;

          this.serverItems[i].filesize = response.data[i].filesize;

          //this.serverItems[i].iconClass = "mdi-file";
          console.log(this.serverItems[i].filepng);
        }
      })
      .catch((error) => {
        console.log(error);
        //this.errored = true;
      });

    if (store.state.augmentableTheme) {
      this.isActive = true;
    } else {
      this.isActive = false;
    }

    if (this.isActive === false) {
      this.$vuetify.theme.dark = false;
    } else if (this.isActive === true) {
      this.$vuetify.theme.dark = true;
    }
  },
  methods: {
    funcc(glb, id) {
      this.$emit("location", glb, id);
      //console.log("hi image click");
    },
    printEd(x) {
      console.log(x);
      console.log("Edit");
    },
    printDe(y) {
      console.log(y);
      console.log("Delete");

      axios
        .delete(this.$abServerPath + "/api/glbfiles/glbdeletefile/" + y + "/")
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
          //this.errored = true;
        });

      axios
        .get(this.$abServerPath + "/api/glbfiles/glbgetallfile/")
        .then((response) => {
          var i;
          var len;

          //console.log(response.data.length);
          this.serverItems = response.data;
          //console.log(this.serverItems);
          //console.log(this.serverItems[0]);
          //console.log(this.items);
          //console.log(response.data[2].filepng);
          for (i = 0, len = response.data.length; i < len; i++) {
            console.log(response.data[i]);
            this.serverItems[i].filepng =
              this.$abServerPath + response.data[i].filepng;
            this.serverItems[i].filename = response.data[i].filename;
            this.serverItems[i].filetype = response.data[i].filetype;
            this.serverItems[i].fileglb =
              this.$abServerPath + response.data[i].fileglb;
            this.serverItems[i].fileusdz =
              this.$abServerPath + response.data[i].fileusdz;
            console.log(this.serverItems[i].fileglb);
            this.serverItems[i].filedescription = response.data[i].description;
            this.serverItems[i].filetag = response.data[i].tags;
            this.serverItems[i].filestate = response.data[i].state;
            this.serverItems[i].filecreated = response.data[i].created_at;
            this.serverItems[i].fileupdated = response.data[i].updated_at;

            this.serverItems[i].filesize = response.data[i].filesize;

            //this.serverItems[i].iconClass = "mdi-file";
            console.log(this.serverItems[i].filepng);
          }
        })
        .catch((error) => {
          console.log(error);
          //this.errored = true;
        });
    },
  },
};
</script>


<style lang="scss" scoped>
.picsArea {
  width: 100%;
  height: 60%;
  //background-color: #555555;
  border-bottom: 1px solid #d3d3d3;
  position: absolute;
}
.foldersArea {
  top: 60%;
  width: 100%;
  height: 40%;
  //background-color: #262626;
  position: absolute;
  overflow-y: auto;
}
.innerFolderArea {
  top: 20%;
  left: 20%;
  width: 60%;
  height: 60%;
  //background-color: lawngreen;
  position: absolute;
}
</style>